






























































































































































import { Vue, Component } from "vue-property-decorator";
import { User } from "@/components/User";

@Component
export default class Apps extends Vue {
  get isDev() : boolean {
    return !!window.location.host.match(/^localhost/i);
  }
  get SelectedApp() : string {
    return this.$store.getters.SelectedApp;
  }

  gotoApp(app:string) {
    this.$store.commit('notifyChange', {
      ForAdmin: false
    });
    let hash = window.location.hash;
    if (hash) {
      if (hash.indexOf('?')>0) {
        //has always starts with '#' and exists at the end of url.
        //however, it may be wrongly placed before query parameters
        //so we need to detect and extract it correctly
        hash = hash.substring(0,hash.indexOf('?'));
      }
      hash = hash.substr(1); // remove #
    } else {
      hash = window.location.pathname.substr(1);
    }
    if (hash.match(/map/i)) {
      hash = 'gisagromap';
    }
    if (hash==app) {
      window.name = app;
      //if (app=='land' && !this.user.hasLoggedIn) {
      //  app = 'login';
      //}
      // in case that we are already in window 'softoo'
      this.$store.commit('notifyChange', {
        Page: app
      });
    } else {
      let url;
      if (window[app]) {
        url = '';
      } else {
        url = window.location.protocol + '//' + 
              window.location.hostname + 
              (window.location.port ? ':' + window.location.port : '');
        url += '/' + (app.match(/gisagromap/i) ? 'map' : app);
      }
      window.name = 'GISagro';
      window[app] = window.open(url, app);
      window[app].focus();
    }
  }

  get user() : User {
    return this.$store.getters.User;
  }
}
